import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('you_were_invited_to_the_provalmax_organisations'),
    description: defineMessage('after_accepting_the_inv__and_the_administrators'),
    invitedBy: defineMessage('invitation_from_name'),
    accept: defineMessage('accept'),
    next: defineMessage('next'),
};
